'use client';
import React, { useState, useCallback } from 'react';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';
import Link from 'next/link';
import { WeatherData } from '@/lib/types';

interface AppLayoutProps {
  children: React.ReactNode;
  weatherData?: WeatherData;
}

const FALLBACK_WEATHER: WeatherData = {
  station: 'CYRC',
  isRealData: false,
  dataSource: 'CYRC',
  lastUpdated: '--:--',
  metar: {
    raw: '',
    time: '',
    ageMinutes: 0,
    windDirection: 0,
    windSpeed: 0,
    gustSpeed: 0,
    visibility: 15,
    ceiling: 99999,
    ceilingLayer: 'CLR',
    temperature: 0,
    dewpoint: 0,
    pressure: 1013,
    weather: 'RAS',
    clouds: [],
    flightCategory: 'VFR',
  },
  taf: { raw: '', decoded: '', issuedAt: '' },
  supplemental: {
    humidity: 0,
    feelsLike: 0,
    sunrise: '--:--',
    sunset: '--:--',
    vfrRecommendedStart: '--:--',
    vfrRecommendedEnd: '--:--',
    civilDawn: '--:--',
    civilDusk: '--:--',
    densityAltitude: 0,
    pressureTrend: 'stable',
  },
};

export default function AppLayout({ children, weatherData: initialWeatherData }: AppLayoutProps) {
  const [weatherData] = useState<WeatherData>(initialWeatherData ?? FALLBACK_WEATHER);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = useCallback(async () => {
    setIsRefreshing(true);
    try {
      window.location.reload();
    } catch {
      // ignore
    } finally {
      setIsRefreshing(false);
    }
  }, []);

  return (
    <div
      className="flex flex-col bg-background"
      style={{
        height: '100dvh',
        width: '100vw',
        maxWidth: '100vw',
        overflowX: 'hidden',
      }}
    >
      <AppHeader
        weatherData={weatherData}
        onRefresh={handleRefresh}
        isRefreshing={isRefreshing}
      />
      <main
        className="flex-1 min-h-0"
        style={{ overflowX: 'hidden' }}
      >
        {children}
      </main>
      {/* Discrete footer */}
      <div className="shrink-0 flex items-center justify-center py-1 px-4 bg-white border-t border-slate-100">
        <p className="text-center text-slate-400" style={{ fontSize: '0.6rem', lineHeight: '1.4' }}>
          Application créée par{' '}
          <Link
            href="/contact-gestion-pvjm"
            className="text-slate-500 underline underline-offset-2 hover:text-slate-700 transition-colors"
          >
            gestionpvjm.com
          </Link>
        </p>
      </div>
      <BottomNav />
    </div>
  );
}